<template>
  <div class="main-view" v-loading.body="loading">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" class="inline-form">
        <el-form-item label="商户编号">
          <el-input v-model="searchInfo.merchantId" clearable></el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-input v-model="searchInfo.activityName" clearable></el-input>
        </el-form-item>
        <el-form-item label="活动编号">
          <el-input v-model="searchInfo.activityCode" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchInfo.orderType" placeholder="请选择" clearable>
            <el-option
            v-for="item in orderOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="开卡状态">
          <el-select v-model="searchInfo.cardStatus" placeholder="请选择" clearable>
            <el-option
            v-for="item in cardOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="searchLoading"></auth-button>
          <auth-button opt="clear" :plain="true" @click.native="exportClick" label="清空" ></auth-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 提取记录table -->
      <el-table
        style="width:100%;"
        stripe
        border
        v-loading="searchLoading"
        :data="packagelist"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column v-for="item in labelHeader" :key="item.key" :property="item.key" :label="item.label" align="center" >
            <template slot-scope="scope">
                {{scope.row[scope.column.property]}}
            </template>
        </el-table-column>
      </el-table>
      <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo" :size="paginations.pageSize"></pagination>
    </el-card>
  </div>
</template>

<script>
import qs from 'qs'
import pagination from '@/components/pagination'
import { getUnionList } from '@/api/machine'

export default {
  name: 'UnionpayReceiptOrder',
  components: {
    pagination
  },
  data () {
    return {
      searchLoading: false,
      packagelist: '',
      orderAmonut: '',
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        merchantId: '',
        activityName: '',
        activityCode: '',
        orderType: -1,
        cardStatus: -1
      },
      orderOptions: [{
        value: -1,
        label: '全部'
      }, {
        value: 0,
        label: '报名成功商户'
      }, {
        value: 1,
        label: '办卡商户'
      }, {
        value: 2,
        label: '达标商户'
      }],
      cardOptions: [{
        value: -1,
        label: '全部'
      }, {
        value: 0,
        label: '无效'
      }, {
        value: 10,
        label: '未预约'
      }, {
        value: 20,
        label: '已预约'
      }, {
        value: 30,
        label: '已开卡'
      }, {
        value: 40,
        label: '已绑卡'
      }],
      labelHeader: [{
        label: '商户编号',
        key: 'merchantId'
      }, {
        label: '店铺名称',
        key: 'merchantName'
      }, {
        label: '状态',
        key: 'orderTypeStr'
      }, {
        label: '报名时间',
        key: 'createTime'
      }, {
        label: '活动名称',
        key: 'activityName'
      }, {
        label: '活动编号',
        key: 'activityCode'
      }, {
        label: '业务员名称',
        key: 'agentName'
      }, {
        label: '业务员编号',
        key: 'agentId'
      }, {
        label: '开卡状态',
        key: 'cardStatusStr'
      }, {
        label: '地址',
        key: 'address'
      }]
    }
  },
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getPackageList()
    },
    searchClick () {
      this.paginations.pageNo = 1
      this.paginations.count = 0
      this.getPackageList()
    },
    getPackageList () {
      this.searchLoading = true
      const params = qs.stringify(Object.assign(this.searchInfo, this.paginations))
      getUnionList(params).then(data => {
        this.searchLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          if (data.list) {
            this.packagelist = data.list
            this.paginations.count = data.totalCount
          }
        }
      })
    }
  },
  mounted () {
    this.getPackageList()
  }
}
</script>

<style lang="scss" scoped>
  @mixin flex-horizontal {
  display: -webkit-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.extract-amount {
  @include flex-horizontal;
  justify-content: center;
  margin: 30px 0;
  .extract-amount-input {
    margin-left: 15px;
    width: 300px;
    .extract-all {
      cursor: pointer;
    }
  }
}
</style>
